import React, { Component } from 'react'
import propTypes from 'prop-types'
import { connect } from 'react-redux'
import { getTranslation } from '@/store/getters'

import styles from './styles.scss'

/** Components */
import Input from '@/components/Input'
import RadioButton from '@/components/RadioButton'

class LinkUrl extends Component {
  state = {
    url: '',
    target: '_blank'
  }

  componentDidMount() {
    const { url, target } = this.props.url

    this.setState({ url, target })
  }

  handleUrl = (type, value) => {
    if (type === 'url' && !!value) {
      const regex = /https?:\/\//
      const newLink = regex.test(value) ? value : `http://${value}`
      value = newLink
    }

    this.setState(prevState =>
      ({ [type]: value }),
      () => this.props.onChange(this.state)
    )
  }

  render() {
    const { translation } = this.props
    const { url, target } = this.state

    return (
      <div className={styles['wrapper-link-url']}>
        <Input
          placeholder="https://example.com"
          value={url}
          onChange={({ target }) => this.handleUrl('url', target.value)}
          className={"ba-input ba-w-100"}
        />
        <div className={styles['wrapper-link-url__options']}>
          <div className='ba-flex ba-ai-center'>
            <RadioButton
              id="link-blank"
              name="link-url"
              checked={'_blank' === target}
              value="_blank"
              onChange={({ target }) => this.handleUrl('target', target.value)}
            />
            <label htmlFor="link-blank" className={'_blank' === target ? 'ba-color-blue1' : ''}>{translation('link-blank')}</label>
          </div>
          <div className='ba-mg-t-1'>
            <RadioButton
              id="link-self"
              name="link-url"
              checked={'_top' === target}
              value="_top"
              onChange={({ target }) => this.handleUrl('target', target.value)}
            />
            <label htmlFor="link-self" className={'_top' === target ? 'ba-color-blue1' : ''}>{translation('link-self')}</label>
          </div>
        </div>
      </div>
    )
  }
}

LinkUrl.propTypes = {
  url: propTypes.shape({
    url: propTypes.string,
    target: propTypes.string
  }),
  onChange: propTypes.func,
}

LinkUrl.defaultProps = {
  url: {
    url: '',
    target: '_blank'
  },
  onChange: () => { }
}

const mapStateToProps = state => {
  const translation = getTranslation(state)

  return { translation }
}


export default connect(mapStateToProps)(LinkUrl)


// WEBPACK FOOTER //
// ./src/components/LinkUrl/index.js